module.exports = __webpack_public_path__ + "static/media/main point_2.3e3db76c.svg";